module.exports = __webpack_public_path__ + "img/117.af58c9cb.png";